import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
  List,
  ListItem
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { NavLink } from 'react-router-dom';
import UserMenu from '../UserMenu';
import SessionConstants from '../../config/SessionConstants';
import { clearViewState } from '../../utils/ProgramSummaryViewState.js';
import { useSignalRStatusNotification } from "../StatusFeed/useSignalR";

export default function Navbar({ menuContainerRef }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [fullscreen] = useState(JSON.parse(sessionStorage.getItem(SessionConstants.FULLSCREEN)));
  const [programId] = useState(sessionStorage.getItem(SessionConstants.PROGRAM_ID));
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
 const [statusFeed, setStatusFeed] = useState(null);
     // initialize SignalR
    useSignalRStatusNotification((message) => {
      setStatusFeed(message);
    });
  const navLinks = [
    {
      label: 'Home',
      to: '/home',
    },
    {
      label: 'Evaluate',
      to: '/programsummary',
      state: {
        programId: programId,
      },
      onClick: clearViewState,
    },
    {
      label: 'Explore',
      to: '/explore',
      state: {
        programId: programId,
      },
    },
    {
      label: 'Educate',
      to: '/educate',
      state: {
        programId: programId,
      },
    },
    {
      label: 'Help',
      to: '/help',
    },
  ];

  const drawerContent = (
    <nav role="navigation" aria-label="Main navigation">
      <Box sx={{ width: 250 }} role="presentation" onClick={() => setDrawerOpen(false)}>
        <List component="ul" disablePadding>
          {navLinks.map(({ label, to, state, disabled, onClick }) => (
            <ListItem component="li" key={label} disablePadding>
              {disabled ? (
                <Box
                  sx={{
                    display: 'block',
                    py: 1.5,
                    px: 2,
                    opacity: 0.5,
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    letterSpacing: '0.08em',
                  }}
                >
                  {label}
                </Box>
              ) : (
                <NavLink
                  to={to}
                  state={state}
                  onClick={onClick}
                  style={{
                    display: 'block',
                    padding: '12px 16px',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    letterSpacing: '0.08em',
                  }}
                >
                  {label}
                </NavLink>
              )}
            </ListItem>
          ))}
        </List>
      </Box>
    </nav>
  );

  return (
    <AppBar position="static" elevation={1} className="headerBkg">
      <Toolbar 
        disableGutters 
        sx={{
          minHeight: 60,
          [theme.breakpoints.up('sm')]: {
            minHeight: 60,
          },
        }}
      >
        <div
          className={fullscreen ? 'container-wide' : 'container'}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
        >
          {/* Left side: hamburger + title */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {isMobile && (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open navigation menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}

            <Typography
              variant="h6"
              component={NavLink}
              to="/home"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                fontSize: '1.8214rem',
                fontFamily: 'var(--font)',
                textTransform: 'uppercase',
              }}
            >
              Ed3n
            </Typography>
          </Box>

          {/* Right side: nav links (if desktop) + user menu */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!isMobile &&
            navLinks.map(({ label, to, state, disabled, onClick }) => (
              <NavLink
                key={label}
                to={to}
                state={state}
                onClick={disabled ? (e) => e.preventDefault() : onClick}
                className={({ isActive }) => (isActive ? 'active' : '')}
                style={{ textDecoration: 'none', pointerEvents: disabled ? 'none' : 'auto' }}
              >
                <Box
                  sx={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    px: 2,
                    color: 'inherit',
                    textTransform: 'uppercase',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    letterSpacing: '0.08em',
                    color: disabled ? 'var(--disabled-gray)' : 'white',
                    opacity: 1,
                    '&:hover': {
                      backgroundColor: 'rgba(0,0,0,0.1)',
                    },
                    '&.active': {
                      backgroundColor: 'rgba(0,0,0,0.2)',
                      boxShadow: 'inset 0 -3px 0 white',
                    },
                  }}
                  className={window.location.pathname === to ? 'active' : ''}
                >
                  {label}
                </Box>
              </NavLink>
            ))}

            <Box sx={{ marginLeft: theme.spacing(2) }}>
              <UserMenu menuContainerRef={menuContainerRef} message={statusFeed} />
            </Box>
          </Box>
        </div>
      </Toolbar>

      <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        {drawerContent}
      </Drawer>
    </AppBar>
  );
}
